import PropTypes from 'prop-types';
import { size } from '@/helpers/lodash';
import { channelGridSizeCountMap } from '@/config/pages/channel';
import { classes } from '@/helpers/styling';
import ConnectedShowPreviewSlate from '@/components/app/ConnectedShowPreviewSlate';
import ShowPreviewSlate from '@/components/component-library/ShowPreviewSlate';
import useLoadingMoreCount from '@/hooks/layout/useLoadingMoreCount';
import { createImageAltTextForShow } from '@/helpers/seo/shows';

const LOADING_COUNT = 7;

const ShowPreviewGrid = ({
  id,
  channels,
  onClickChannel,
  loading,
  loadingMore,
  className,
  hideSlateOverlayInfo,
  streamingContext
}) => {
  const { loadingMoreCount } = useLoadingMoreCount({
    sizeCountMap: channelGridSizeCountMap,
    listLength: size(channels)
  });

  if (!loading && !size(channels)) {
    return null;
  }

  return (
    <ul className={ classes('channel-grid', className) }>
      { size(channels) && !loading
        ? (
          <>
            { channels.map((channel, i) => (
              <ConnectedShowPreviewSlate
                altText={ createImageAltTextForShow({ show: channel }) }
                assets={ !!channel && channel.assets }
                centerShowInfo
                displayShowInfo
                key={ `${ id }-${ channel.id }` }
                onClick={ (onClickChannel && !loading) ? () => onClickChannel(channel) : undefined }
                priority={ i === 0 }
                showFormat={ !!channel && channel.format }
                showId={ channel ? channel.id : null }
                showSlug={ channel.slug }
                showTitle={ !!channel && channel.title }
                streamingContext={ streamingContext }
                useOverlay
                useOverlayContent={ !hideSlateOverlayInfo }
              />
            )) }
            { loadingMore && [...Array(loadingMoreCount)].map((_, i) => (
              <ShowPreviewSlate
                centerShowInfo
                displayShowInfo
                key={ `${ id }-loading-more-${ i }` }
                loading
              />
            )) }
          </>
        ) : [...Array(LOADING_COUNT)].map((_, i) => (
          <ShowPreviewSlate
            centerShowInfo
            displayShowInfo
            key={ `${ id }-loading-${ i }` }
            loading
          />
        )) }
    </ul>
  );
};

ShowPreviewGrid.propTypes = {
  id: PropTypes.string,
  loading: PropTypes.bool,
  loadingMore: PropTypes.bool,
  channels: PropTypes.array,
  onClickChannel: PropTypes.func.isRequired,
  className: PropTypes.string,
  hideSlateOverlayInfo: PropTypes.bool,
  streamingContext: PropTypes.string
};

ShowPreviewGrid.defaultProps = {
  id: '',
  loading: false,
  loadingMore: false,
  channels: [],
  className: '',
  hideSlateOverlayInfo: false,
  streamingContext: undefined
};

export default ShowPreviewGrid;